import {AfterViewInit, Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Parcel } from '../_models/parcel';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { ApiService } from '../_services/api.service';
import { ChatServiceService } from '../_services/chatService.service';
import {SiteConfigService} from "../_services/site-config.service";
import {EnvironmentService} from "../_services/environment.service";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    providers: [
        { provide: CarouselConfig, useValue: { interval: 4900, showIndicators: true } }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit  {
  selector = true;
  returnUrl: string;
  siteConfigService = inject(SiteConfigService);
  envService = inject(EnvironmentService);
  // Same targets as the nav's REGISTER / SIGN IN (SIGN IN's login() reloads onto /login)
  eServicesLinks = {
    loginUrl: '/login?returnUrl=%2F',
    registerUrl: this.envService.getSsoRegisterUrl(),
    learnMoreUrl: '/news-information/eservices-account-upgrades'
  };
  constructor(public router: Router, private apiService: ApiService, private route: ActivatedRoute, public chatService: ChatServiceService,) {


  }



  getAddress(event: Parcel) {

    this.router.navigateByUrl('/homeowners/property-search', { state: event });

  }
  ngOnInit(): void {
    this.getHeaders();
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnurl');

    if(this.returnUrl)
      this.router.navigate([this.returnUrl]);

  }

  goToUrl(url: string) {
    console.log(url)
    this.router.navigateByUrl(url);
  }


  getHeaders() {
    // this.apiService.eFile().subscribe(data => {
    //   console.log(data);
    //  })
    //  this.apiService.ePost().subscribe(data => {
    //   console.log(data);
    //  })

  }

}
